import React, { useEffect } from 'react';

import { sentrySetUser } from 'app/packages/components/Sentry/sentry-set-user';

type SentrySetUserProps = {
  clientId: string;
};

export const SentrySetUser = ({ clientId }: SentrySetUserProps) => {
  useEffect(() => {
    sentrySetUser({ clientId });
  }, [clientId]);

  return <></>;
};
